import {Flex, Heading, Image, Text} from '@chakra-ui/react';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IRestaurant} from 'types';

import {ReviewsCount} from './components';

interface Props {
  t: (term: TranslationKeys) => string;
  provider: IRestaurant;
  subTitle: string;
}

export const ProviderTitle: FC<Props> = ({subTitle, provider, t}) => {
  const {name, online_payment} = provider;

  return (
    <Flex flex="1" pb={['5px', '30px']} alignItems="flex-end">
      <Flex flexDirection={['column', 'row']} alignItems={['flex-start', 'center']}>
        <Flex ml={['0px', '30px']} mt={['15px', 'auto']} flexDirection="column">
          <Flex alignItems="center" mt="0px">
            <Heading as="h1" fontSize={['18px', '48px']} fontWeight="bold" color="white">
              {name}
            </Heading>
            {provider.ratings?.count && <ReviewsCount provider={provider} t={t} />}
          </Flex>
          <Flex mt={['0px', '12p']} alignItems="center">
            <Text as="h4" fontSize={['18px', '24px']} fontWeight="600" color="white">
              {subTitle}
            </Text>
            {online_payment && (
              <Flex position={['absolute', 'initial']} bottom="17px" right="15px">
                <Image
                  src="/icons/master-card.svg"
                  alt="Master-card"
                  ml="10px"
                  w={['40px', 'auto']}
                  bg="white"
                  borderRadius="5.3px"
                />
                <Image
                  src="/icons/visa.svg"
                  alt="Visa"
                  ml={['15px', '10px']}
                  w={['40px', 'auto']}
                  bg="white"
                  borderRadius="5.3px"
                />
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
